import axios from "axios";
import { makeUseAxios } from "axios-hooks";

const serviceEndpoints =
  process.env.REACT_APP_BASE_URL || "http://localhost:5000";

let axiosInstance = axios.create({
  baseURL: serviceEndpoints,
  headers: {
    "Content-Type": "application/json",
    API_KEY: "iV5JT0ihurrHooq8G4AzGq05pRldEq1X",
  },
});

// Add request interceptor to dynamically get token on each request
axiosInstance.interceptors.request.use(
  (config) => {
    const tokenRaw = localStorage.getItem("token");
    const token = tokenRaw ? JSON.parse(tokenRaw) : null;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Ignore cancel errors
    if (axios.isCancel(error)) {
      return Promise.reject({ canceled: true });
    }
    // Create a proper error object to avoid [object Object] display
    const errorMessage = error?.response?.data?.msg ||
                        error?.response?.data?.error ||
                        error?.message ||
                        "An unexpected error occurred";
    const enhancedError = new Error(errorMessage);
    enhancedError.response = error.response;
    enhancedError.originalError = error;
    return Promise.reject(enhancedError);
  }
);

export const useAxios = makeUseAxios({
  axios: axiosInstance,
});

// Export axios instance for direct API calls (bypasses axios-hooks cancellation)
export { axiosInstance };

// Server-supplied paths (image URLs, for example) are relative to the API, which
// is a different origin during local development.
export const apiUrl = (path) => {
  if (!path) return path;
  if (/^https?:\/\//i.test(path)) return path;
  return `${serviceEndpoints}${path}`;
};
